export const CONSENT_TYPE_NAME = {
  EMAIL_ALERTS: 'EmailAlerts',
  EMAIL_EVENTS: 'EmailEvents',
  EMAIL_PROMOTIONS: 'EmailPromotions',
  EMAIL_GLOBAL: 'EmailGlobal',
  EMAIL_OFFERS: 'EmailOffers',
  TCPA: 'Tcpa',
  SOFTPULL: 'SoftPull'
};

export const CONSENT_CHANNEL_STRING = {
  GENERAL: 'General'
};

export const CONSENT_SUBTYPE_NAME = {
  SOFTPULL: 'SoftPull',
  CREDIT_MONITORING: 'CreditMonitoring'
};

export const CONSENT_SOURCE = 'Merch - Account UI';
